<template>
  <div
    class="subtleshadow tag-element tag-dense"
    v-if="dense"
    :style="`background: ${color}`">
    <v-icon
      style="opacity: 0.85"
      v-if="icon"
      :class="name?.toString().length > 0 ? 'mr-2' : ''">
      {{ icon }}
    </v-icon>
    <div style="opacity: 0.85">{{ name }}</div>
  </div>
  <div
    class="subtleshadow tag-element tag-normal"
    v-else
    :style="`background: ${color}`">
    <v-icon
      style="opacity: 0.85"
      v-if="icon"
      :class="name?.toString().length > 0 ? 'mr-2' : ''">
      {{ icon }}
    </v-icon>
    <div style="opacity: 0.85">{{ name }}</div>
  </div>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  name: String,
  dense: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'var(--main-bg-color)',
  },
  icon: String,
});
</script>
<style scoped>
.tag-element {
  min-width: max-content !important;
  max-width: unset !important;
  widows: unset !important;
}

.tag-element div {
}
.tag-dense {
  margin-right: 6px;
  color: white;
  font-size: 14px;
  padding: 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  opacity: 0.88;
  height: 28px;
  color: white;
  user-select: none;
  cursor: pointer;
  min-width: 20px;
}
.tag-normal {
  margin-right: 6px;
  color: white;
  font-size: 14px;
  padding: 10px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  opacity: 0.88;
  height: 34px;
  color: white;
  user-select: none;
  cursor: pointer;
  min-width: 100px;
}
</style>
